import { render, staticRenderFns } from "./KidDashboard.vue?vue&type=template&id=1a542591&scoped=true&"
import script from "./KidDashboard.vue?vue&type=script&lang=js&"
export * from "./KidDashboard.vue?vue&type=script&lang=js&"
import style0 from "./KidDashboard.vue?vue&type=style&index=0&id=1a542591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a542591",
  null
  
)

export default component.exports